export const OFFER_EXPIRY_PLACEHOLDER = "((offer_expiry_timer))";

export const OFFER_ICON_DIM = {
    HEIGHT: "16px",
    WIDTH: "16px",
};

export const TIMER_ICON_DIM = {
    HEIGHT: "14px",
    WIDTH: "14px",
};
